import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';

const RegistrationApiWrapper = (requests: any) => {
	return {
		checkUniqueness: (fieldConfig: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get(`/customer/account/is-value-unique/${fieldConfig.field}/${fieldConfig.value}`, config);
		},
		sendSms: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/customer/account/pre-register`, body, config);
		},
		register: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/customer/account/register`, body, config);
		},
	};
};

export default RegistrationApiWrapper;
